const getUserBrowserGeolocation = async () => {
	if (!navigator.geolocation) {
		throw new Error('Geolocation is not supported by this browser.');
	}

	if (navigator.permissions) {
		const permission = await navigator.permissions.query({
			name: 'geolocation',
		});
		if (permission.state === 'denied') {
			throw new Error(
				'Location permission has been denied. Please enable it in your browser settings.',
			);
		}
	}

	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(
			(position) => {
				resolve({
					latitude: position.coords.latitude,
					longitude: position.coords.longitude,
				});
			},
			() => {
				reject(
					new Error(
						'Unable to retrieve your location. Please check your browser settings and try again.',
					),
				);
			},
		);
	});
};

export default getUserBrowserGeolocation;
